import { Icon } from '../Icon/Icon';
import { WeaveIconButton } from '../WeaveIconButton/WeaveIconButton';
import styles from './styles.module.scss';

export const FullScreenButton = ({ element }: { element: HTMLElement | null }) => {

	if (!element) return null;

	const isFullscreenAvailable = document.fullscreenEnabled;
	// Hide button if fullscreen is not available (e.g., in iframe without permission)
	if (!isFullscreenAvailable) return null;

	const handleClick = async () => {
		try {
			if (!document.fullscreenElement) {
				await element.requestFullscreen();
			} else {
				await document.exitFullscreen();
			}
		} catch (error) {
			console.warn('Fullscreen not available:', error);
		}
	};

	return (
		<WeaveIconButton className={styles.fullScreenButton} onClick={handleClick}>
			<Icon name="forma-camera-options-caret-24" />
		</WeaveIconButton>
	)
}
